export const isValidFontFamily = (fontFamily: string): boolean => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    return false;
  }

  const text = "abcdefghijklmnopqrstuvwxyz0123456789";
  context.font = "72px monospace";
  const defaultWidth = context.measureText(text).width;

  context.font = `72px ${fontFamily}, monospace`;
  const testWidth = context.measureText(text).width;

  return testWidth !== defaultWidth;
};
